export default {
    namespaced: true,

    state: {
        dark: false,
        localDark: false,
        isSearching: false
    },
    getters: {
        getTheme(state) {
            return state.dark
        },
        getLocalTheme(state) {
            return state.localDark
        },
        getSearching(state) {
            return state.isSearching
        }
    },
    mutations: {
        SET_THEME_MAP(state, val) {
            state.dark = val
        },
        SET_LOCAL_THEME(state, val) {
            state.localDark = val
        },
        SET_SEARCHING(state, val) {
            state.isSearching = val;
        }
    },
    actions: {
        setTheme({ commit }, val) {
            commit('SET_THEME_MAP', val)
        },
        setLocalTheme({ commit }, val) {
            commit('SET_LOCAL_THEME', val)
        },
        setSearching({ commit }, val) {
            commit('SET_SEARCHING', val)
        },
    }
}